<template>
    <Teleport to="body">
      <div v-if="isVisible" class="dialog-overlay">
        <div class="dialog">
          <div class="header flex-container">
            <slot name="header"><h6>{{ title }}</h6></slot>
          </div>
          <div class="modal-divider">
              <div class="divider-line"></div>
          </div>
          <div class="modal-body">
            <slot name="body">
              <p>Please also ensure to answer the question below correctly to continue</p>    
              </slot>
          <br>
          <div class="buttons flex-container">
          <p>{{ question }}</p>
          <input class="custom-input" type="number" v-model="userAnswer" placeholder="Result" />
      </div>    </div>
      <br>    <br>
          <div class="buttons flex-container">
            <button class="custom-button confirm" @click="confirm">Confirm</button>
            <button class="custom-button cancel"  @click="cancel">Cancel</button>
          </div>
        </div>
      </div>
    </Teleport>
  </template>
  
  <script>
  export default {
    props: {
      isVisible: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        userAnswer: '',
        question: '',
        correctAnswer: 0,
      };
    },
    methods: {
      generateQuestion() {
        const num1 = Math.floor(Math.random() * 20) + 1; // Random number between 1-20
        const num2 = Math.floor(Math.random() * 20) + 1; // Random number between 1-20
        this.correctAnswer = num1 + num2;
        this.question = `What is the result for ${num1} + ${num2}?`;
      },
      confirm() {
        if (this.userAnswer == this.correctAnswer) {
          this.$emit('confirmed');
          this.userAnswer = ''; // Reset answer
        } else {
          alert('Incorrect answer. Please try again.');
        }
      },
      cancel() {
        this.$emit('cancelled');
        this.userAnswer = ''; // Reset answer
      },
    },
    watch: {
      isVisible(newVal) {
        if (newVal) {
          this.generateQuestion();
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999 !important;
  }
  .dialog {
    background: var(--card-bg);
    padding: 20px;
    border-radius: 5px;
    position: relative;
    z-index: 100000 !important;
  }
  .buttons {
    margin-top: 10px;
  }
    .flex-container {
        flex-direction: row;
        gap: 60px;
    }
    .custom-button {
        color: var(--text-primary)
    }
    .confirm{
        background-color: var(--custom-color2);
  }

  .cancel{
    background-color: var(--custom-color1);
  }

  .modal-body {
    margin: 20px;
  }

  .divider-line {
    height: 3px;
    border-top: 1px solid #e0e0e0;
    background-color: red;
  }
  </style>
  